import * as React from "react";
import {
    Divider,
    IconButton,
    ListItem,
    ListItemText,
    Typography
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { BauvorhabenWithID } from "../../../../../services/openapi";

interface IBauvorhabenListItemProps {
    item: BauvorhabenWithID;
    onDelete: (id: number, name: string) => void;
}

export default function BauvorhabenListItem(props: IBauvorhabenListItemProps) {
    const { item, onDelete } = props;

    return (
        <React.Fragment>
            <ListItem
                sx={{
                    transition: 'background-color 0.2s',
                    '&:hover': {
                        bgcolor: 'action.hover',
                    },
                    py: 1.5
                }}
                secondaryAction={
                    <IconButton
                        color="error"
                        edge="end"
                        aria-label="delete"
                        onClick={() => onDelete(item.id, item.bvh_name)}
                    >
                        <DeleteIcon/>
                    </IconButton>
                }
            >
                <ListItemText
                    primary={
                        <Typography variant="subtitle1" component="div" fontWeight="medium">
                            {item.bvh_name}
                        </Typography>
                    }
                    secondary={
                        <Typography variant="body2" color="text.secondary">
                            Mandant: {item.mandnr}, Projektnummer: {item.projektnr}
                        </Typography>
                    }
                />
            </ListItem>
            <Divider component="li" />
        </React.Fragment>
    );
} 